import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class SaturatedUnitWeightGamaSatCalculationMethodModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (SaturatedUnitWeightGamaSatCalculationMethodModel._instance == null) SaturatedUnitWeightGamaSatCalculationMethodModel._instance = new SaturatedUnitWeightGamaSatCalculationMethodModel(authManager);
        return SaturatedUnitWeightGamaSatCalculationMethodModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'geo-sections/saturated-unit-weight-gama-sat-calculation-methods', 'geo-sections/saturated-unit-weight-gama-sat-calculation-methods/codelist');

        this.entityName = 'geo-sections.SaturatedUnitWeightGamaSatCalculationMethod';
        this.privileges = {
            create: [["#admin"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'Saturated Unit Weight Gama Sat Calc Method';
        this.setLabel = 'Saturated Unit Weight Gama Sat Calc Methods';

        this.browser = {
            name: 'default-geo-sections-saturatedunitweightgamasatcalculationmethod-browser',
            moduleName: 'default-geo-sections-saturatedunitweightgamasatcalculationmethod-browser',
            moduleTitle: 'Saturated Unit Weight Gama Sat Calc Methods',
            moduleStateSlotName: 'default-geo-sections-saturatedunitweightgamasatcalculationmethod-browser',
        };

        this.editor = {
            name: 'default-geo-sections-saturatedunitweightgamasatcalculationmethod-editor',
            moduleName: 'default-geo-sections-saturatedunitweightgamasatcalculationmethod-editor',
            moduleTitle: 'Saturated Unit Weight Gama Sat Calc Method',
            moduleStateSlotName: 'default-geo-sections-saturatedunitweightgamasatcalculationmethod-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
